import React from 'react';
import { envEnums } from '../../enums/enums';

const TextsWithUrl = ({ linkUrl, text }) => {

  const matchResult = text.match(/\{(.+?)\}/);
  const textInsideBraces = matchResult ? matchResult[1] : '';

  const parts = text.split(`{${textInsideBraces}}`);
  const domain = process.env.REACT_APP_DOMAIN;

  const getColorByDomain = (domain) => {
    switch (domain) {
      case envEnums.SCANNED_PAGE:
        return "#28c254";
      case envEnums.QCI:
        return "#14a0ee";
      case envEnums.QBOX:
        return "#14a0ee";  
      default:
        return "#28c254";
    }
  };

  const linkColor = getColorByDomain(domain);

  const content = parts.map((part, index) => {
    if (index < parts.length - 1) {
      return (
        <React.Fragment key={index}>
          {part}
          <a href={linkUrl} style={{ color: linkColor }}>{textInsideBraces}</a>
        </React.Fragment>
      );
    } else {
      return <React.Fragment key={index}>{part}</React.Fragment>;
    }
  });

  return <span>{content}</span>;
};

export default TextsWithUrl;

